<template>
  <div class="root-box">
    <el-row class="condition">
      <el-form size="small" :inline="true">
        <el-form-item label="车牌号：">
          <el-input v-model="param.vehicleNo" clearable placeholder="车牌号" style="width: 140px" />
        </el-form-item>
        <el-form-item label="司机姓名：">
          <el-input v-model.number="param.driverName" clearable placeholder="司机姓名" style="width: 120px" />
        </el-form-item>
        <el-form-item label="司机编号：">
          <el-input v-model.number="param.driverNo" clearable placeholder="司机编号" style="width: 120px" />
        </el-form-item>
        <el-form-item label="缴款标记：">
          <el-select v-model="param.jkbj" placeholder="请选择" clearable style="width: 100px">
            <el-option label="未缴" value="0" />
            <el-option label="已缴款" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="处理标记：">
          <el-select v-model="param.clbj" placeholder="请选择" clearable style="width: 100px">
            <el-option label="未处理" value="0" />
            <el-option label="已处理" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query()">查询</el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="success" icon="el-icon-mobile-phone" @click="openG12123Dialog">12123 扫码</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <div class="table">
      <el-table ref="violationTable" :data="list" stripe max-height="600" :summary-method="getSummaries" show-summary>
        <el-table-column label="序号" type="index" width="50" />
        <el-table-column prop="vehicleNo" label="车牌号" width="100" />
        <el-table-column prop="driverName" label="司机姓名" width="80" />
        <el-table-column prop="driverNo" label="编号" width="80"
          :sort-method="(a, b) => sortByNumber(a, b, 'driverNo')" />
        <el-table-column prop="wfsj" label="违章时间" width="160" />
        <el-table-column prop="wfms" label="违章描述" min-width="140" show-overflow-tooltip />
        <el-table-column prop="wfdz" label="违章地址" min-width="120" show-overflow-tooltip />
        <el-table-column prop="wfjfs" label="记分数" width="120" sortable
          :sort-method="(a, b) => sortByNumber(a, b, 'wfjfs')" />
        <el-table-column prop="fkje" label="罚款金额" width="140" sortable :sort-method="(a, b) => sortByFkje(a, b)" />
        <el-table-column prop="jkbj" label="缴款标记" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.jkbj === '1' ? 'success' : 'info'" size="small">
              {{ scope.row.jkbj === '1' ? '已缴款' : '未缴' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="clbj" label="处理标记" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.clbj === '1' ? 'success' : 'warning'" size="small">
              {{ scope.row.clbj === '1' ? '已处理' : '未处理' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column width="150" label="车辆图片">
          <template slot-scope="scope">
            <el-image style="width: 80px; height: 60px" v-if="scope.row.photos && scope.row.photos.length"
              :src="scope.row.photos[0]" :preview-src-list="[scope.row.photos]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormat('yyyy-MM-dd hh:mm:ss') }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDialog(scope.row)">编辑</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>

    <div class="page">
      <el-pagination background :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="total" @current-change="handleCurrentChange" />
    </div>

    <el-dialog :title="form.id ? '编辑违章记录' : '新增违章记录'" :visible.sync="dialogVisible" width="680px" @close="resetForm">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="120px" size="small">
        <el-form-item label="车牌号" prop="vehicleNo">
          <el-input v-model="form.vehicleNo" placeholder="车牌号" />
        </el-form-item>
        <el-form-item label="司机姓名" prop="driverName">
          <el-input v-model.number="form.driverName" placeholder="司机姓名" />
        </el-form-item>
        <el-form-item label="司机编号" prop="driverNo">
          <el-input v-model.number="form.driverNo" placeholder="司机编号" />
        </el-form-item>
        <el-form-item label="违章时间" prop="wfsj">
          <el-input v-model="form.wfsj" placeholder="如：2024-01-01 12:00:00" />
        </el-form-item>
        <el-form-item label="违章描述" prop="wfms">
          <el-input v-model="form.wfms" type="textarea" :rows="2" placeholder="违章描述" />
        </el-form-item>
        <el-form-item label="违章地址" prop="wfdz">
          <el-input v-model="form.wfdz" placeholder="违章地址" />
        </el-form-item>
        <el-form-item label="违章行为代码" prop="wfxw">
          <el-input v-model="form.wfxw" placeholder="违章行为代码" />
        </el-form-item>
        <el-form-item label="采集机关名称" prop="cjjgmc">
          <el-input v-model="form.cjjgmc" placeholder="采集机关名称" />
        </el-form-item>
        <el-form-item label="违章记分数" prop="wfjfs">
          <el-input-number v-model="form.wfjfs" :min="0" :max="12" placeholder="记分数" />
        </el-form-item>
        <el-form-item label="罚款金额" prop="fkje">
          <el-input v-model="form.fkje" placeholder="罚款金额" />
        </el-form-item>
        <el-form-item label="缴款标记" prop="jkbj">
          <el-select v-model="form.jkbj" placeholder="请选择" style="width: 100%">
            <el-option label="未缴" value="0" />
            <el-option label="已缴款" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="处理标记" prop="clbj">
          <el-select v-model="form.clbj" placeholder="请选择" style="width: 100%">
            <el-option label="未处理" value="0" />
            <el-option label="已处理" value="1" />
          </el-select>
        </el-form-item>

      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>

    <!-- 12123 扫码弹框 -->
    <el-dialog title="12123 扫码登录" :visible.sync="g12123DialogVisible" width="560px" class="g12123-dialog"
      append-to-body>
      <div class="g12123-content">
        <el-tabs v-model="activeAccount" @tab-click="handleAccountClick">
          <el-tab-pane v-for="(account, index) in accountList" :key="index" :label="account.name" :name="String(index)">
            <div class="account-content">
              <div class="account-info">
                <p><strong>账户名称：</strong>{{ account.name }}</p>
              </div>
              <div class="g12123-date-range">
                <el-date-picker v-model="g12123DateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期" value-format="yyyy-MM-dd" size="small" style="width: 100%" />
                <p class="date-tip">不选择则默认查询近3个月</p>
              </div>
              <div class="login-status-tip" v-if="account.loginStatus && !account.qrCodeUrl">
                <el-tag type="success">已登录</el-tag>
                <span class="tip-desc">无需扫码，可直接执行任务</span>
              </div>
              <div class="qr-code-section" v-if="account.qrCodeUrl">
                <p class="tip-text">请使用12123 APP扫描下方二维码登录</p>
                <div class="qr-code-container">
                  <img :src="account.qrCodeUrl" alt="登录二维码" class="qr-code-img" />
                </div>
                <p class="status-text" v-if="account.loginStatus">
                  <el-tag type="success">已登录</el-tag>
                </p>
              </div>
              <div class="action-buttons">
                <el-button type="primary" :loading="account.loading" @click="getQrCode(index)"
                  v-if="!account.qrCodeUrl && !account.loginStatus">
                  获取二维码
                </el-button>
                <el-button type="success" @click="verifyLogin(index)" v-if="account.qrCodeUrl">
                  验证登录
                </el-button>
                <el-button type="success" @click="doG12123Query(index)" v-if="account.accountId && account.loginStatus">
                  执行任务
                </el-button>
                <el-button type="info" @click="resetAccount(index)">
                  重置
                </el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ParamUtil } from "@/util";
import {
  listVehicleViolation,
  getVehicleViolationInfo,
  saveOrUpdateVehicleViolation,
  getG12123QrCode,
  verifyG12123Login,
  doG12123Task,
  getG12123IsLogin
} from "@/api";

const G12123_ACCOUNT_LIST = [
  { accountId: "武汉优选顺风科技有限公司岳阳分公司", name: "武汉优选顺风科技有限公司岳阳分公司", qrCodeUrl: "", token: "", loginStatus: false, loading: false, verifying: false },
  { accountId: "武汉吉豪汽车销售员有限公司", name: "武汉吉豪汽车销售有限公司", qrCodeUrl: "", token: "", loginStatus: false, loading: false, verifying: false },
  { accountId: "武汉昌吉源汽车租凭有限公司", name: "武汉昌吉源汽车租赁有限公司", qrCodeUrl: "", token: "", loginStatus: false, loading: false, verifying: false },
  { accountId: "岳阳保哥汽车租赁有限公司", name: "岳阳保哥汽车租赁有限公司", qrCodeUrl: "", token: "", loginStatus: false, loading: false, verifying: false }
];

export default {
  name: "ViolationRecord",
  data() {
    return {
      g12123DialogVisible: false,
      activeAccount: "0",
      accountList: JSON.parse(JSON.stringify(G12123_ACCOUNT_LIST)),
      g12123DateRange: null,
      param: {
        vehicleNo: "",
        vehicleId: null,
        driverId: null,
        jkbj: "",
        clbj: ""
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      dialogVisible: false,
      submitLoading: false,
      form: {
        id: "",
        vehicleNo: "",
        driverName: "",
        driverNo: "",
        wfsj: "",
        wfms: "",
        wfdz: "",
        wfxw: "",
        cjjgmc: "",
        wfjfs: null,
        fkje: "",
        jkbj: "0",
        clbj: "0",
        photos: []
      },
      photosStr: "",
      rules: {
        vehicleNo: [{ required: true, message: "请输入车牌号", trigger: "blur" }]
      }
    };
  },
  created() {
    this.query();
  },
  methods: {
    query(page = 1) {
      const param = {
        page: { current: page, size: this.pageSize },
        param: ParamUtil.filterEmptyData(this.param)
      };
      listVehicleViolation(param).then((res) => {
        const { records = [], current = 1, total = 0 } = res.data || {};
        this.list = records;
        this.currentPage = current;
        this.total = total;
      });
    },
    handleCurrentChange(page) {
      this.query(page);
    },
    /** 按数字排序（司机编号、记分数） */
    sortByNumber(a, b, prop) {
      const va = a[prop] != null ? Number(a[prop]) : 0;
      const vb = b[prop] != null ? Number(b[prop]) : 0;
      return va - vb;
    },
    /** 按罚款金额排序（支持纯数字或带单位字符串） */
    sortByFkje(a, b) {
      const parse = (v) => {
        if (v == null || v === "") return 0;
        if (typeof v === "number") return v;
        const num = parseFloat(String(v).replace(/[^\d.-]/g, ""));
        return isNaN(num) ? 0 : num;
      };
      return parse(a.fkje) - parse(b.fkje);
    },
    /** 汇总行 */
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "wfjfs") {
          const total = data.reduce((sum, row) => sum + (Number(row.wfjfs) || 0), 0);
          sums[index] = total;
          return;
        }
        if (column.property === "fkje") {
          const parse = (v) => {
            if (v == null || v === "") return 0;
            if (typeof v === "number") return v;
            const num = parseFloat(String(v).replace(/[^\d.-]/g, ""));
            return isNaN(num) ? 0 : num;
          };
          const total = data.reduce((sum, row) => sum + parse(row.fkje), 0);
          sums[index] = total.toFixed(2);
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    openDialog(row) {
      if (row && row.id) {
        getVehicleViolationInfo(row.id).then((res) => {
          const data = res.data || {};
          this.form = { ...this.form, ...data };
          this.photosStr = Array.isArray(data.photos) ? data.photos.join(",") : (data.photos || "");
        });
      } else {
        this.form = {
          id: "",
          vehicleNo: "",
          driverName: "",
          driverNo: "",
          wfsj: "",
          wfms: "",
          wfdz: "",
          wfxw: "",
          cjjgmc: "",
          wfjfs: null,
          fkje: "",
          jkbj: "0",
          clbj: "0",
          photos: []
        };
        this.photosStr = "";
      }
      this.dialogVisible = true;
    },
    resetForm() {
      this.form = {
        id: "",
        vehicleNo: "",
        driverName: "",
        driverNo: "",
        wfsj: "",
        wfms: "",
        wfdz: "",
        wfxw: "",
        cjjgmc: "",
        wfjfs: null,
        fkje: "",
        jkbj: "0",
        clbj: "0",
        photos: []
      };
      this.photosStr = "";
      this.$refs.formRef && this.$refs.formRef.clearValidate();
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        const photos = this.photosStr
          ? this.photosStr.split(",").map((s) => s.trim()).filter(Boolean)
          : [];
        const payload = { ...this.form, photos };
        this.submitLoading = true;
        saveOrUpdateVehicleViolation(payload).then(() => {
          this.submitLoading = false;
          this.$message.success("保存成功");
          this.dialogVisible = false;
          this.query(this.currentPage);
        }).catch(() => {
          this.submitLoading = false;
        });
      });
    },
    openG12123Dialog() {
      this.accountList = JSON.parse(JSON.stringify(G12123_ACCOUNT_LIST));
      this.activeAccount = "0";
      this.g12123DialogVisible = true;
      this.fetchG12123LoginStatus();
    },
    /** 打开弹框时先获取各账户登录状态，已登录则无需扫码 */
    fetchG12123LoginStatus() {
      this.accountList.forEach((account, index) => {
        getG12123IsLogin(account.accountId).then((res) => {
          if (res.data === true) {
            this.$set(this.accountList[index], "loginStatus", true);
          }
        });
      });
    },
    handleAccountClick() { },
    getQrCode(index) {
      const account = this.accountList[index];
      account.loading = true;
      getG12123QrCode(account.accountId).then((res) => {
        account.loading = false;
        if (res.data && res.data.img) {
          account.qrCodeUrl = res.data.img;
          account.token = res.data.token || "";
          account.loginStatus = false;
          this.$message.success("二维码获取成功，请使用12123 APP扫码登录");
        } else {
          this.$message.error("获取二维码失败");
        }
      }).catch(() => {
        account.loading = false;
        this.$message.error("获取二维码失败");
      });
    },
    verifyLogin(index) {
      const account = this.accountList[index];
      if (!account.token || account.token.trim() === "") {
        this.$message.warning("请先获取二维码");
        return;
      }
      account.verifying = true;
      verifyG12123Login(account.accountId, account.token).then((res) => {
        account.verifying = false;
        if (res.data === true) {
          account.loginStatus = true;
          this.$message.success("登录验证成功，可以执行查询任务");
        } else {
          account.loginStatus = false;
          this.$message.warning("登录验证失败，请重新扫码");
        }
      }).catch(() => {
        account.verifying = false;
        account.loginStatus = false;
        this.$message.error("验证登录失败");
      });
    },
    doG12123Query(index) {
      const account = this.accountList[index];
      if (!account.loginStatus) {
        this.$message.warning("请先扫码登录并验证");
        return;
      }
      const options = {};
      if (this.g12123DateRange && this.g12123DateRange.length === 2) {
        options.startDate = this.g12123DateRange[0];
        options.endDate = this.g12123DateRange[1];
      }
      doG12123Task(account.accountId, options).then(() => {
        this.$message.success("查询成功");
        this.query(this.currentPage);
      });
    },
    resetAccount(index) {
      const account = this.accountList[index];
      account.qrCodeUrl = "";
      account.token = "";
      account.loginStatus = false;
      this.$message.success("账户已重置");
    }
  }
};
</script>

<style scoped>
.root-box {
  padding: 20px;
}

.condition {
  background: #fff;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
}

.table {
  background: #fff;
  padding: 0 16px 16px;
  border-radius: 4px;
}

.page {
  margin-top: 16px;
  text-align: right;
}

.danger-text {
  color: #f56c6c;
}

.g12123-dialog .g12123-content {
  min-height: 320px;
}

.g12123-content .account-content {
  padding: 16px 0;
}

.g12123-content .account-info {
  margin-bottom: 16px;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 4px;
}

.g12123-content .account-info p {
  margin: 0;
  font-size: 14px;
}

.g12123-content .g12123-date-range {
  margin-bottom: 16px;
  padding: 12px;
  background: #fafafa;
  border-radius: 4px;
}

.g12123-content .date-tip {
  margin: 4px 0 0;
  font-size: 12px;
  color: #909399;
}

.g12123-content .login-status-tip {
  margin-bottom: 16px;
  padding: 12px;
  background: #f0f9eb;
  border-radius: 4px;
  text-align: center;
}

.g12123-content .login-status-tip .tip-desc {
  margin-left: 8px;
  font-size: 13px;
  color: #67c23a;
}

.g12123-content .qr-code-section {
  text-align: center;
  margin: 20px 0;
}

.g12123-content .tip-text {
  color: #606266;
  font-size: 13px;
  margin-bottom: 12px;
}

.g12123-content .qr-code-container {
  display: inline-block;
  padding: 16px;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-bottom: 12px;
}

.g12123-content .qr-code-img {
  width: 180px;
  height: 180px;
  display: block;
}

.g12123-content .status-text {
  margin-top: 8px;
}

.g12123-content .action-buttons {
  margin: 16px 0;
  text-align: center;
}

.g12123-content .action-buttons .el-button {
  margin: 0 8px;
}
</style>
